import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Button, Col, Modal, Row} from "react-bootstrap";
import {MdModeEdit} from "react-icons/md";
import {FaRegTrashAlt} from "react-icons/fa";
import DeleteModal from "../../../primer/POPUP-COMPONENTS/Delete-Modal/deleteModal";
import BankingCategoryModal from "./banking-settings-category-modal";
import axios from "axios";
import {toast} from "react-toastify";
import {
    BANKING_INSERTION_DISABLED_CATEGORIES,
    DISABLED_BANKING_CATEGORIES,
    quickClone
} from "../../../../_helpers/commonFunctions";
import {
    fetchAccountingRecordCategories,
    fetchAccountingRecordSubcategories,
    fetchBankingSettings
} from "../../../../_apis/api";

const BankingSettings = () => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);

    const categories = useSelector((state) => state.ACCOUNTING_DATA.bankingCategories);
    const subCategories = useSelector((state) => state.ACCOUNTING_DATA.bankingSubCategories);

    const [openSubCategories, setOpenSubCategories] = useState([]); // Array of ids

    const [modalType, setModalType] = useState("new");
    const [categoryType, setCategoryType] = useState("category");
    const [defaultObject, setDefaultObject] = useState({});
    const [show, setShow] = useState(false);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [toBeDeleted, setToBeDeleted] = useState("");

    const [showOnboardBanking, setShowOnboardBanking] = useState(false);
    const [loadingOnboard, setLoadingOnboard] = useState(false);

    const newCategoryInitialValue = {
        title: "",
        threshold: 60,
    }

    const newSubCategoryInitialValue = {
        parentCategory: "",
        title: "",
        transactionSign: "+",
        installation: "0",
        section: "Client Payments",
        documentType: "",
        accountingCategory: "",
        accountingSubCategory: "",
        balancingAccount: "",
        accounts: [],
        isActive: true,
    }

    useEffect(() => {
        dispatch(fetchAccountingRecordCategories(company.id));
        dispatch(fetchAccountingRecordSubcategories(company.id));
    }, [])

    const renderSubCategoryRow = (cat, idx) => {
        const compArr = [];
        if (openSubCategories.includes(cat._id)) {
            const subCats = subCategories.filter((el) => el.parentCategory === cat._id);
            if (subCats.length > 0) {
                subCats.forEach((subCat, idx2) => {
                    compArr.push(
                        <tr className={"subCategory"} key={`ct-${idx}-${idx2}`} style={{cursor: "pointer"}} onClick={(e) => {
                            e.stopPropagation();
                            openSubCategoryEdit(subCat);
                        }}>
                            <td></td>
                            <td>{subCat.title}</td>
                            <td>
                                <div className={"product-settings-button product-settings-edit-style"} title={"Επεξεργασία"} onClick={(e) => {
                                    e.stopPropagation();
                                    openSubCategoryEdit(subCat);
                                }}>
                                    <MdModeEdit size={22} />
                                </div>
                                {!DISABLED_BANKING_CATEGORIES.includes(subCat.title) && (
                                    <div className={"product-settings-button product-settings-delete-style"} title={"Διαγραφή"} onClick={(e) => {
                                        e.stopPropagation();
                                        setToBeDeleted(subCat._id);
                                        setCategoryType("subCategory");
                                        setShowDeleteModal(true);
                                    }}>
                                        <FaRegTrashAlt size={22} />
                                    </div>
                                )}
                            </td>
                        </tr>
                    );
                });
            }
            if (!BANKING_INSERTION_DISABLED_CATEGORIES.includes(cat.title)) {
                compArr.push(
                    <tr key={`ct-${idx}`}>
                        <td colSpan={3} style={{
                            textDecoration: "underline",
                            textDecorationStyle: "dotted",
                            cursor: "pointer",
                            backgroundColor: "lightyellow",
                        }} onClick={() => openSubCategoryNew(cat)}>+ Δημιουργία νέας υποκατηγορίας στην κατηγορία {cat.title}</td>
                    </tr>
                )
            }
        }
        return compArr;
    }

    const toggleSubCategories = (cat) => {
        if (openSubCategories.includes(cat._id)) {
            setOpenSubCategories(openSubCategories.filter((el) => el !== cat._id));
        } else {
            setOpenSubCategories([...openSubCategories, cat._id]);
        }
    }

    const toggleAllSubCategories = () => {
        if (openSubCategories.length === categories.length) {
            setOpenSubCategories([]);
        } else {
            setOpenSubCategories(categories.map((o) => o._id));
        }
    }

    const openCategoryNew = () => {
        setModalType("new");
        setCategoryType("category");
        setDefaultObject({
            ...newCategoryInitialValue,
        });
        setShow(true);
    }

    const openSubCategoryNew = (parentCategory) => {
        setModalType("new");
        setCategoryType("subCategory");
        setDefaultObject({
            ...newSubCategoryInitialValue,
            parentCategory: parentCategory._id,
        });
        setShow(true);
    }

    const openCategoryEdit = (cat) => {
        setModalType("edit");
        setCategoryType("category");
        setDefaultObject({
            ...cat,
        });
        setShow(true);
    }

    const openSubCategoryEdit = (subCat) => {
        setModalType("edit");
        setCategoryType("subCategory");
        setDefaultObject({
            ...subCat,
        });
        setShow(true);
    }

    const closeModal = () => {
        setModalType("new");
        setCategoryType("category");
        setDefaultObject({});
        setShow(false);
    }

    const onModalAction = (obj) => {
        const cloneIt = quickClone(obj);
        axios.post(`${process.env.REACT_APP_API_URL2}/accounting/banking-category-action`, {
            modalType,
            categoryType,
            company: company.id,
            data: cloneIt,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής αποθήκευση.");
                closeModal();
                dispatch(fetchBankingSettings(company.id));
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const onboardBanking = () => {
        setLoadingOnboard(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/ai/onboard-banking`, {
            companyId: company.id,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής αρχικοποίηση.");
                setShowOnboardBanking(false);
                dispatch(fetchBankingSettings(company.id));
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        }).finally(() => {
            setLoadingOnboard(false);
        })
    }

    return (
        <React.Fragment>
            <Row className={"mb-2"}>
                <Col md={12} className={"d-flex justify-content-end"}>
                    <Button onClick={() => openCategoryNew()}>+ Δημιουργία κατηγορίας</Button>
                </Col>
            </Row>

            <Row>
                <Col md={12}>
                    <table className={"product-settings-table mb-3"}>
                        <colgroup>
                            <col span={1} style={{width: "5%"}}></col>
                            <col span={1} style={{width: "80%"}}></col>
                            <col span={1} style={{width: "20%"}}></col>
                        </colgroup>
                        <thead>
                        <tr>
                            <th style={{cursor: "pointer", userSelect: "none", fontWeight: "600"}} title={"Προβολή Υποκατηγοριών"} onClick={(e) => {
                                e.stopPropagation();
                                toggleAllSubCategories();
                            }}>
                                {openSubCategories.length === categories.length ? "-" : "+"}
                            </th>
                            <th>Τίτλος</th>
                            <th>Ενέργειες</th>
                        </tr>
                        </thead>
                        <tbody>
                        {categories.map((cat, idx) => (
                            <React.Fragment>
                                <tr key={`ct-${idx}`} style={{cursor: "pointer"}} onClick={() => openCategoryEdit(cat)}>
                                    <td style={{cursor: "pointer", userSelect: "none", fontWeight: "600"}} title={"Προβολή Υποκατηγοριών"} onClick={(e) => {
                                        e.stopPropagation();
                                        toggleSubCategories(cat);
                                    }}>
                                        {openSubCategories.includes(cat._id) ? "-" : "+"}
                                    </td>
                                    <td style={{fontWeight: "600"}}>{cat.title}</td>
                                    <td>
                                        <div className={"product-settings-button product-settings-edit-style"} title={"Επεξεργασία"} onClick={(e) => {
                                            e.stopPropagation();
                                            openCategoryEdit(cat)
                                        }}>
                                            <MdModeEdit size={22} />
                                        </div>
                                        {!DISABLED_BANKING_CATEGORIES.includes(cat.title) && (
                                            <div className={"product-settings-button product-settings-delete-style"} title={"Διαγραφή"} onClick={(e) => {
                                                e.stopPropagation();
                                                setToBeDeleted(cat._id);
                                                setCategoryType("category");
                                                setShowDeleteModal(true);
                                            }}>
                                                <FaRegTrashAlt size={22} />
                                            </div>
                                        )}
                                    </td>
                                </tr>
                                {renderSubCategoryRow(cat)}
                            </React.Fragment>
                        ))}
                        </tbody>
                    </table>
                </Col>
            </Row>

            <Row>
                <Col md={12}>
                    <Button size={"sm"} onClick={() => setShowOnboardBanking(true)}>Αρχικοποίηση ρυθμίσεων</Button>
                </Col>
            </Row>

            <BankingCategoryModal
                modalType={modalType}
                categoryType={categoryType}
                show={show}
                setShow={setShow}
                defaultObject={defaultObject}
                callbackFunction={onModalAction}
            />

            <DeleteModal
                showDelete={showDeleteModal}
                showDeleteModal={setShowDeleteModal}
                toBeDeleted={toBeDeleted}
                tableName={categoryType === "category" ? "Banking Categories" : "Banking Sub Categories"}
                updateFunction={() => {
                    dispatch(fetchBankingSettings(company.id));
                }}
            />

            <Modal show={showOnboardBanking} onHide={() => setShowOnboardBanking(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Αρχικοποίηση Ρυθμίσεων Όψεως</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Είσαστε σίγουροι ότι θέλετε να αρχικοποίησετε τις ρυθμίσεις του Όψεως;
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowOnboardBanking(false)}>
                        Όχι, κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => onboardBanking()} disabled={loadingOnboard}>
                        Ναι, αρχικοποίηση
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default BankingSettings;
